// Validates and defaults launcher fields so published widgets and builder controls use the same allowed values.
import { z } from "zod";
import { colorValidated } from "./configPrimitives.js";
export const LauncherSchema = z.object({
    backgroundColor: colorValidated("#007bff").nullable().default(null),
    borderRadius: z.number().int().min(0).max(28).default(12),
    position: z.enum(["bottom-right", "bottom-left"]).default("bottom-right"),
    offsetX: z.number().int().min(0).max(160).default(20),
    offsetY: z.number().int().min(0).max(160).default(20),
    zIndex: z.number().int().min(0).max(2147483647).default(2147483646),
    teaserText: z.string().max(160).default(""),
    showUnreadIndicator: z.boolean().default(false),
});
//# sourceMappingURL=launcher.js.map